<template>
  <div class="course-content-container mb-3">
    <CourseContentHeaderComponent
      :course="course"
      :getHumanDate="getHumanDate"
      :watch_lesson="watch_lesson"
    />
  </div>
  <div class="all-units">
    <ul class="units-header">
      <li
        v-for="(unit, index) in units"
        :key="index"
        @click="change_unit_content(unit?.id, index)"
        :class="{ active: unit?.id == selected_unit?.id }"
      >
        {{ unit?.name }}
      </li>
    </ul>
    <div class="unit-content row d-flex a;ign-items-start">
      <div
        v-if="is_loading_content"
        class="col-12 d-flex justify-content-center align-items-center"
      >
        <span
          class="spinner-border"
          style="color: #f1c40f; width: 5rem; height: 5rem"
        ></span>
      </div>
      <h1
        v-if="!is_loading_content && unit_content_data.length === 0"
        class="col-12 d-flex justify-content-center align-items-center no-content"
      >
        لا يوجد محتوي في هذه الوحده
      </h1>
      <template v-if="!is_loading_content && unit_content_data.length > 0">
        <div
          class="col-lg-5 lesson"
          v-for="(item, index) in unit_content_data"
          :key="index"
        >
          <div class="image">
            <img src="../../assets/banner-bg.jpg" alt="" />
            <span v-if="item?.type == 'lesson'" style="font-size: 0.8rem"
              >{{ item?.video_duration }} دقائق</span
            >
          </div>
          <div class="lesson-data d-flex flex-column justify-content-between">
            <div>
              <h5
                class="fw-bold d-flex justify-content-between align-items-start"
              >
                {{ item?.name }}
              </h5>
              <p>{{ item?.description }}</p>
            </div>

            <template v-if="course?.has_subscription">
              <!-- show lesson content before enter it if have exam or file for enc videos -->

              <div
                v-if="item?.exam || item?.file"
                class="lesson-content d-flex align-items-center"
              >
                <router-link
                  v-if="item?.exam"
                  :to="{
                    name: 'startExam',
                    params: {
                      exam_id: item?.exam?.id,
                      exam_name: item?.exam?.name,
                    },
                  }"
                >
                  (واجب) {{ item?.exam?.name }}</router-link
                >

                <a :href="item?.file" target="_blank" v-if="item?.file">
                  الذهاب الي الملف</a
                >
              </div>

              <router-link
                class="watch-btn"
                v-if="item?.type == 'lesson'"
                :to="{
                  name: 'lesson',
                  params: { course_id: id, lesson_id: item?.id },
                }"
              >
                مشاهده الان
              </router-link>
              <router-link
                class="watch-btn"
                v-if="item?.type == 'exam'"
                :to="{
                  name: 'startExam',
                  params: { exam_id: item?.id, exam_name: item?.title },
                }"
              >
                الذهاب الي الاختبار
              </router-link>
              <button
                @click="get_file(item?.id)"
                class="watch-btn"
                v-if="item?.type == 'file' && !file_load"
              >
                الذهاب الي الملف
              </button>
              <button
                class="watch-btn"
                v-if="item?.type == 'file' && file_load"
              >
                <span class="spinner-border"></span>
              </button>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import config from "@/services/config";
import axios from "axios";
import CourseContentHeaderComponent from "@/components/CourseContentHeader/CourseContentHeaderComponent.vue";
import Swal from "sweetalert2";
// import UnitBoxComponent from "@/components/UnitBox/UnitBoxComponent.vue";
export default {
  name: "CourseContentView",
  components: {
    CourseContentHeaderComponent,
    // UnitBoxComponent,
  },
  props: ["id"],
  data() {
    return {
      course: {},
      selected_unit: null,
      units: [],
      unit_content_data: [],
      is_loading_content: false,
      watch_lesson: {},
    };
  },
  mounted() {},

  methods: {
    open_lesson_content(template_id) {
      const template = this.$refs[template_id][0];
      Swal.fire({
        title: "هذا الدرس يحتوي علي",
        html: template.innerHTML,
        showConfirmButton: false,
      });
    },
    getCourse() {
      axios
        .get(`${config.basURL}course/course-details/${this.id}`, {
          headers: {
            auth: this.$store.state.userToken,
          },
        })
        .then((res) => {
          this.course = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    getUnit() {
      axios
        .get(`${config.basURL}course/unit-list/${this.id}`)
        .then((res) => {
          this.units = res.data;
          this.selected_unit = res.data.length > 0 && res.data[0];
          res.data.length > 0 && this.get_unit_content(res.data[0].id);
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    get_unit_content(unit_id) {
      this.is_loading_content = true;
      this.unit_content_data = [];
      axios
        .get(
          `${config.basURL}subscription/unit-content-subscription/${unit_id}`,
          {
            headers: {
              auth: this.$store.state.userToken,
            },
          }
        )
        .then((res) => {
          // console.log('unit content', res.data);
          this.unit_content_data = res.data;
          this.watch_lesson = res.data.filter(
            (lesson) => lesson?.type == "lesson"
          )[0];
        })
        .catch((err) => {
          console.log(err.message);
        })
        .finally(() => {
          this.is_loading_content = false;
        });
    },
    getHumanDate(d) {
      const date = new Date(d);
      const options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return date.toLocaleDateString("ar", options);
    },
    change_unit_content(unit_id, index) {
      this.selected_unit = this.units[index];
      this.get_unit_content(unit_id);
    },
    get_file(file_id) {
      this.file_load = true;
      axios
        .get(
          `${config.basURL}subscription/access-content/${this.id}/file/${file_id}`,
          {
            headers: {
              auth: this.$store.state.userToken,
            },
          }
        )
        .then((res) => {
          // console.log(res.data)
          window.open(res.data.file, "_blank");
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            text: "حدث خطاء اثناء تحميل الملف حاول مره اخري لاحقا",
            icon: "error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
          });
        })
        .finally(() => {
          this.file_load = false;
        });
    },
  },
  created() {
    this.getCourse();
    this.getUnit();
  },
};
</script>

<style scoped>
.lesson-content {
  margin-bottom: 10px;
  justify-content: center;
}

.lesson-content a {
  all: unset;
  padding: 0.5rem 0;
  flex-grow: 1;
  border: 1px solid #f1c40f;
  color: #f1c40f !important;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
}

.lesson-content a:not(:last-child) {
  margin-left: 0.5rem;
}

.course-content-container {
  height: 100vh;
}

.no-content {
  color: #000;
  font-size: 1.5rem;
  font-weight: 700;
}

body.dark .no-content {
  color: #fff;
}

.all-units {
  padding: 2rem;
}

.all-units .units-header {
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
  flex-wrap: wrap;
}

.all-units .units-header * {
  color: #000;
}

body.dark .all-units .units-header * {
  color: #fff;
}

.all-units .units-header li {
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 700;
  padding: 0.5rem;
  opacity: 0.5;
  transition: all ease-in-out;
  margin-bottom: 1rem;
}

.all-units .units-header li:not(:last-child) {
  margin-left: 1rem;
}

.all-units .units-header li.active {
  opacity: 1;
  border-bottom: 5px solid #f1c40f;
}

.unit-content {
  min-height: 50vh;
  counter-reset: section;
  display: flex;
  row-gap: 2rem;
  column-gap: 1rem;
}

.unit-content * {
  color: #000;
}

body.dark .unit-content * {
  color: #fff;
}

.unit-content .lesson {
  padding: 0.5rem;
  /* margin-bottom: 2rem; */
  display: flex;
  width: calc(100% / 2 - 1rem);
}

.unit-content .lesson .image {
  width: 30%;
  position: relative;
  border: 5px solid #000;
  background-color: #fefefe;
}

.unit-content .lesson .image span {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

body.dark .unit-content .lesson .image {
  border: 5px solid #fff;
  background-color: #1e1e1e;
}

body.dark .unit-content .lesson .image::before {
  color: #fff;
}

.unit-content .lesson .image::before {
  color: #f1c40f;
  counter-increment: section;
  content: counter(section);
  font-size: 3rem;
  bottom: 5px;
  left: 10px;
  font-weight: bold;
  position: absolute;
}

.unit-content .lesson .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.unit-content .lesson .lesson-data {
  width: 100%;
  padding: 0 1rem;
}

::v-deep(.unit-content .lesson .watch-btn) {
  all: unset;
  padding: 0.5rem;
  background-color: #f1c40f;
  color: #000 !important;
  text-align: center;
  cursor: pointer;
  display: block;
  font-weight: bold;
  width: 100%;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
}

.unit-content .lesson .watch-btn {
  all: unset;
  padding: 0.5rem;
  background-color: #f1c40f;
  color: #000 !important;
  text-align: center;
  cursor: pointer;
  display: block;
  font-weight: bold;
  width: 100%;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
}

.unit-content .lesson .watch-btn:hover {
  background-color: #f39c12;
}

@media (max-width: 1200px) {
  .all-units .units-header {
    flex-direction: column;
    margin-bottom: 2rem;
  }
  .all-units .units-header li {
    width: fit-content;
  }
  .all-units .units-header li:not(:last-child) {
    margin-left: 0;
  }
}
@media (max-width: 992px) {
  .unit-content .lesson {
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
  }
  .unit-content .lesson .image {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .unit-content {
    flex-direction: column;
  }
  .unit-content .lesson {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .all-units .units-header li {
    font-size: 1rem;
    padding: 0 0 0.5rem 0;
  }
}
</style>
